import LabServiceCollection from "@/collections/LabServiceCollection";
import SampleStatusModel from "@/models/lab/SampleStatusModel";

export default class SampleStatusCollection extends LabServiceCollection {
  model() {
    return SampleStatusModel;
  }

}
